import { useTranslations } from "next-intl";
import { Switch } from "@/components/ui/switch";

type DietMenuAllergensToggleProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
};

export const DietMenuAllergensToggle = ({
  checked,
  onCheckedChange,
}: DietMenuAllergensToggleProps) => {
  const t = useTranslations();

  return (
    <div className="flex items-center gap-4">
      <Switch
        checked={checked}
        className="data-[state=checked]:bg-brand-green"
        defaultChecked={false}
        onCheckedChange={onCheckedChange}
        type="button"
      />
      <p className="text-brand-black">{t("diets.show_allergens")}</p>
    </div>
  );
};
